/* eslint-disable react/prop-types */
import { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useStaticQuery, graphql } from 'gatsby';
import Modal from 'react-modal';

import Header from '../header';
import Footer from '../footer';

import '../../styles/main.scss';

import { parseLang } from '../../utils/helpers';

const Layout = ({ children }) => {
	const { header, footer } = useStaticQuery(graphql`
		query {
			header: contentfulContentHeaderSettings(
				groupTitle: { eq: "Header Item Settings" }
			) {
				...HeaderSettingsFields
			}
			footer: contentfulContentFooterSettings(
				groupTitle: { eq: "Footer Item Settings" }
			) {
				...FooterSettingsFields
			}
		}
	`);

	const main = useRef(null);

	useEffect(() => {
		Modal.setAppElement('#___gatsby');
		if (typeof window !== 'undefined') {
			const { localStorage } = window;
			localStorage.removeItem('gatsby-i18next-language');
			localStorage.removeItem('wglang');
		}
		parseLang();
	});

	const handleSkip = () => {
		main.current.focus();
		main.current.tabIndex = -1;
	};

	const handleKeydown = (e) => {
		if (e.key === 'Enter') {
			handleSkip();
		}
	};

	return (
		<div className="root">
			<a
				href="#"
				className="skip-link"
				onClick={() => handleSkip()}
				onKeyDown={handleKeydown}
			>
				Skip to Main Content
			</a>
			<Header
				logo={header?.logo}
				links={header?.mainNavigation}
				cta={header?.bookCta}
				faqs={header?.faQsLink}
				phone={header?.phoneNumber}
			/>
			<main role="main" className="main" ref={main}>
				{children}
			</main>
			<Footer
				logo={footer?.logo}
				links={footer?.mainNavigation}
				cta={footer?.bookCta}
				legalStatement={footer?.legalStatement}
			/>
		</div>
	);
};

Layout.propTypes = {
	children: PropTypes.node.isRequired,
};

export default Layout;
